import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import type { ITemplateResponse } from '@/types/common';
import type {
  TIsabelPredictiveText,
  TIsabelTriageRequest,
  TIsabelTriageData,
  TIsabelDiagnosesRequest,
  TIsabelDiagnosesResponse,
} from '@/types/isabel';

class IsabelApi extends AbortControllerManager {
  private readonly ISABEL_URL = '/v2/isabel';

  getPredictiveText(): Promise<ITemplateResponse<TIsabelPredictiveText>> {
    const signal = this.createAbortController('getPredictiveText');
    return authClient.get(`${this.ISABEL_URL}/predictive-text`, { signal });
  }

  postDiagnoses(
    body: TIsabelDiagnosesRequest,
  ): Promise<ITemplateResponse<TIsabelDiagnosesResponse>> {
    const signal = this.createAbortController('postDiagnoses');
    return authClient.post(`${this.ISABEL_URL}/diagnoses`, body, { signal });
  }

  postTriage(
    body: TIsabelTriageRequest,
  ): Promise<ITemplateResponse<TIsabelTriageData>> {
    const signal = this.createAbortController('postTriage');
    return authClient.post(`${this.ISABEL_URL}/triage`, body, { signal });
  }
}

export const isabelApi = new IsabelApi();
